import { Link, useSearch } from "@tanstack/react-router";
import { cn } from "@/lib/utils";
import type { TaskSearchParams } from "@/types/router";

export default function SettingsSidebar({
    activeRole,
    settingsCategories,
}: {
    activeRole: string;
    settingsCategories: { name: string; slug: string; roles: string[] }[];
}) {
    const search = useSearch({ strict: false }) as TaskSearchParams;

    return (
        <div className="w-[200px] h-full border-r bg-neutral-100 p-3">
            <div className="flex flex-col gap-1">
                {settingsCategories
                    .filter((category) => category.roles.includes(activeRole))
                    .map((category) => (
                        <Link
                            data-active={search.settings === category.slug}
                            className={cn(
                                "text-zinc-500",
                                "rounded-md p-2 text-left outline-none transition-[width,height,padding] focus-visible:ring-2 disabled:pointer-events-none disabled:opacity-50 aria-disabled:pointer-events-none aria-disabled:opacity-50",
                                "data-[active=true]:font-medium data-[active=true]:bg-neutral-200/50 data-[active=true]:text-zinc-950",
                                "hover:bg-neutral-200/50 hover:text-sidebar-accent-foreground h-8 "
                            )}
                            to="."
                            search={{ settings: category.slug }}
                            key={category.name}
                        >
                            {category.name}
                        </Link>
                    ))}
            </div>
        </div>
    );
}
